import React from "react";
import { Typography } from "../../../general/Typography";
import { Chip } from "../../../general/Chip";

interface LevelBadgeProps {
  level: number;
  label?: string;
}

export const LevelBadge = ({ level, label }: LevelBadgeProps) => {
  const title = label ?? `Level ${level}`;
  return <Chip color="info" label={title} />;
};